import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-add-main-product-configuration',
  templateUrl: './add-main-product-configuration.component.html',
  styleUrls: ['./add-main-product-configuration.component.scss'],
})
export class AddMainProductConfigurationComponent {
  @Output() copyProductConfiguration = new EventEmitter<{ payload: any }>();

  modalLabel: string = 'Copy product project';
  productData: any;
  copyProductForm!: FormGroup;
  submitted = false;
  organizationList: any = [];

  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.productData = this.modal?.modalService?.config?.initialState?.['productData'] || {};
    this.organizationList = this.productData?.organizationItems || [];
  }

  setCurrentOrg() {
    return this.organizationList.length > 0
      ? this.organizationList.find((x: any) => x.selected) || this.organizationList[0]
      : null;
  }

  ngOnInit(): void {
    // Initialize the form with proper defaults
    const defaultName = this.productData.name ? `${this.productData.name}_copy` : '';

    this.copyProductForm = this.formBuilder.group({
      productName: [
        defaultName,
        [Validators.required, noWhitespaceValidator, Validators.maxLength(50)],
      ],
      organizationName: [this.setCurrentOrg()],
    });

    // Set validators based on organization list availability
    if (this.organizationList?.length && !this.productData.isCustomItem) {
      this.copyProductForm.get('organizationName')?.setValidators(Validators.required);
    } else {
      this.copyProductForm.get('organizationName')?.clearValidators();
    }

    this.copyProductForm.get('organizationName')?.updateValueAndValidity();
  }

  commonInputSearch(term: string, item: any) {
    if (!term || !item?.name) return false;
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;

    if (this.copyProductForm.invalid) {
      Object.keys(this.copyProductForm.controls).forEach(key => {
        const control = this.copyProductForm.get(key);
        control?.markAsTouched();
      });
      return;
    }

    const productName = this.copyProductForm.get('productName')?.value;
    const organization = this.copyProductForm.get('organizationName')?.value;

    const myTeamsAddEditPayload = {
      id: this.productData.productConfigId,
      name: productName ? productName.trim() : '',
      organizationId: organization?.id,
    };

    this.copyProductConfiguration.emit({ payload: myTeamsAddEditPayload });
    this.modal.close();
  }

  hasError(controlName: string, errorName: string): boolean {
    const control = this.copyProductForm.get(controlName);
    return !!(control && control.touched && control.hasError(errorName));
  }
}
